import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ProjectTreeNode} from '../project-tree.model';
import {ProjectGroup} from '../../../pages/product/product.model';
import {FormBuilder, FormGroup} from '@angular/forms';
import {SystemService} from '../../../services/system.service';
import {ProjectTreeService} from '../project-tree.service';


@Component({
    selector: 'new-node-dialog',
    templateUrl: './new-node.component.html',
    styleUrls: ['./new-node.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class NewNodeComponent implements OnInit {

    parent: ProjectTreeNode;
    entity: ProjectTreeNode;
    entityForm: FormGroup;
    dialogTitle: string;
    type: string;


    constructor(public matDialogRef: MatDialogRef<NewNodeComponent>,
                @Inject(MAT_DIALOG_DATA) private _data: any,
                private formBuilder: FormBuilder,
                public _systemService: SystemService,
                public _projectTreeService: ProjectTreeService) {
        this.parent = _data.parent;
        this.type = _data.type;
        this.entity = new ProjectTreeNode({id: 0, name: '', hasChildren: false});
        this.entityForm = this.createForm();
        this.dialogTitle = this.type === 'Phase' ? 'Nueva Etapa' : 'Nueva Tarea';
    }

    ngOnInit(): void {
        console.log('OnInit Ahora');
    }

    createForm(): FormGroup {
        return this.formBuilder.group({
            name: [this.entity.name],
            type: [this.entity.type]
                });
    }


}
